import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/agent")({
  component: AgentLayout,
});

function AgentLayout() {
  return <Outlet />;
}
